import { render, staticRenderFns } from "./FormPriceDefault.vue?vue&type=template&id=5b795272&"
import script from "./FormPriceDefault.vue?vue&type=script&lang=js&"
export * from "./FormPriceDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports